import { Observable, merge } from "rxjs";
import Handsontable from "handsontable";

export interface ITableChange {
  row: number;
  column: number;
  previousVal?: string | null;
  currentVal?: string | null;
  source: Handsontable.ChangeSource;
}

function getHandsontableChangesStream(table: Handsontable): Observable<ITableChange> {
  return new Observable((subscriber) => {
    table.addHook("afterChange", (changes: Handsontable.CellChange[] | null, source: Handsontable.ChangeSource) => {
      // we only care about small edits on this
      if (changes !== null && source === "edit") {
        for (const change of changes) {
          subscriber.next({
            row: change[0] as number,
            column: change[1] as number,
            previousVal: change[2] as string,
            currentVal: change[3] as string,
            source
          });
        }
      }
    });
  });
}

const cellHasData = (cellValue: string) => cellValue !== "" && cellValue !== undefined && cellValue !== null;

// TODO: Improve this operation
function tableDataCleaning(table: string[][]) {
  for (let j = table.length - 1; j >= 0; j--) {
    if (table[j].some(cellHasData)) {
      return j;
    }
  }
  return 0;
}

function sliceTable(table: any) {
  let t = table.getData() as string[][];
  const i = tableDataCleaning(t);
  t = t.slice(0, i + 1);
  return t;
}

function getHandsontableUndoRedoStream(table: Handsontable, changeTimeout: number): Observable<string[][]> {
  return new Observable((subscriber) => {
    table.addHook("afterChange", (changes: Handsontable.CellChange[] | null, source: Handsontable.ChangeSource) => {
      if (changes !== null && (source === "UndoRedo.redo" || source === "UndoRedo.undo")) {
        window.setTimeout(() => {
          subscriber.next(sliceTable(table));
        }, changeTimeout);
      }
    });
  });
}

function getHandsontablePastesStream(table: Handsontable, changeTimeout: number): Observable<string[][]> {
  return new Observable((subscriber) => {
    table.addHook("afterPaste", () => {
      // We need to queue it enough so that Handsontable has time to update the data
      // Promise.resolve().then and window.requestAnimationFrame were not good enough
      window.setTimeout(() => {
        subscriber.next(sliceTable(table));
      }, changeTimeout);
    });
  });
}

function getHandsontableRemovedRowsStream(table: Handsontable, changeTimeout: number): Observable<string[][]> {
  return new Observable((subscriber) => {
    table.addHook("afterRemoveRow", () => {
      window.setTimeout(() => {
        subscriber.next(sliceTable(table));
      }, changeTimeout);
    });
  });
}

function getHandsontableData(table: Handsontable): Observable<string[][]> {
  const changeClick = 60;
  return merge(
    getHandsontablePastesStream(table, changeClick),
    getHandsontableUndoRedoStream(table, changeClick),
    getHandsontableRemovedRowsStream(table, changeClick)
  );
}

export { getHandsontableChangesStream, getHandsontableData };
